/* eslint-disable max-len */
import React, { Fragment, useRef, useState} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import { useSelector } from 'react-redux';

const Table = ({
    pageNumber, 
    getListData, 
    setToastErrorMessage, 
    searchParams,
    setConfirmationState, handleSidePopupClick,email,setLoading}) => {
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const PurchaseOrderList = useSelector(state => state.purchaseOrderListSlice);
    const { List} = PurchaseOrderList
    
    
    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    
    return (<>
        
        <div className={`flex overflow-auto ${List?.data?.length < 10 ? 'pb-[62px]' : 'pb-[6px]'} scroll-bar px-1`} id = "search-result" >
            <table aria-label="Outside Table" className="w-full table-fixed" id='admin-table'>
                <thead>
                    <tr>
                        <th class="w-[11%]">
                            <span >GRN Date
                            </span>
                        </th>
                        <th class="w-[10%]">
                            <span >GRN #
                            </span>
                        </th>
                        <th class="w-[11%]"> 
                            <span class="flex items-center justify-end">Cost / Item
                            </span>
                        </th>
                        <th class="w-[12%] text-end">
                            <span class="flex items-center justify-end">Received Qty
                            </span>
                        </th>
                        <th class="w-[12%] text-end">
                            <span class="flex items-center justify-end">Available Qty
                            </span>
                        </th>
                        <th class="w-[15%]">
                            <span >Ledger
                            </span>
                        </th>
                        <th class="w-[16%]">
                            <span >Vendor Name
                            </span>
                        </th>
                        <th class="w-[13%]">
                            <span >
                                Vendor #
                            </span>
                        </th>
                    </tr>
                    <tr aria-colspan="7" class="h-1"></tr>
                            
                </thead>
                <tbody>
                    {List?.data?.map((item , index = 0) => (
                        <Fragment key={item._id}>
                            <TableBody
                                tableData={item}
                                setConfirmationState={setConfirmationState}
                                indexNum={index}
                                pageNumber={pageNumber}
                                selectedIndex={selectedIndex}
                                setSelectedIndex={setSelectedIndex}
                                selectedRef={selectedRef}
                                lastIndex={List?.data?.length}
                                email={email}
                                searchParams={searchParams}
                                handleSidePopupClick={handleSidePopupClick}
                                getListData={getListData}
                                setLoading={setLoading}
                                setToastErrorMessage={setToastErrorMessage}
                            />
                        </Fragment>
                    ))}
                        
                </tbody>
                {List?.data?.length === 0 && (
                    <tbody>
                        <tr>
                            <td style={{ 'line-height': '100px' }} colspan="14" className="no-records-message">
                                {`No GRN Entries added yet`}
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>

    </>
    );
}

export default Table;
